import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { AccountingIcon, CatalogIcon, HomeIcon, OrdersIcon, RequestsIcon, SetupIcon } from '../appearance/icons/menu_icons';
import {
    PAGE_MENU_ACCOUNTING,
    PAGE_MENU_CATALOG,
    PAGE_MENU_HOME,
    PAGE_MENU_LIST,
    PAGE_MENU_ORDERS,
    PAGE_MENU_REQUESTS,
    PAGE_MENU_SETUP,
} from '../const/const';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { makeUrl } from '../const/const';
import { getFetchRequest, GET_CURRENT_USER, MAKE_USER_REQUEST, PASSWORD_RESET_INFO } from '../store/requests';

const Home = ({ isCollapsed, setIsCollapsed }) => {
    const [managerName, setManagerName] = useState('');
    const [managerPhone, setManagerPhone] = useState('');
    const [managerEmail, setManagerEmail] = useState('');
    const [dataIsLoad, setDataIsLoad] = useState(false);
    const [searchParams] = useSearchParams();
    const q = searchParams.get('q');
    const filter = searchParams.get('filter');
    const navigate = useNavigate();
    const location = useLocation();
    
    useEffect(() => {
        if(q||filter) {
            navigate(`/${PAGE_MENU_LIST[PAGE_MENU_CATALOG].key}`);
        }
    },[]);

    useEffect(() => {
        const succesGetManagerInfoCallback = async (response) => {
            try {
                if (response && response.ok) {
                    const result = await response.json();
                    setManagerName(result?.name || '');
                    setManagerPhone(result?.phone || '');
                    setManagerEmail(result?.email || '');
                }
            } catch (e) {
                console.error('Failed to parse manager info', e);
            }
            setDataIsLoad(true);
        };

        const succesGetCurrentUserCallback = (response) => {
            if (response?.id) {
                getFetchRequest(
                    makeUrl([MAKE_USER_REQUEST, response.id, '/manager/']),
                    succesGetManagerInfoCallback,
                    () => setDataIsLoad(true),
                    true,
                );
            } else {
                // Фолбэк: если нет авторизации, но есть reset code, получим имя менеджера через password/info
                try {
                    const url = new URL(window.location.href);
                    const code = url.searchParams.get('code');
                    const isSetup = url.pathname === '/setup' && !!code;
                    if (isSetup) {
                        fetch(makeUrl([PASSWORD_RESET_INFO]), {
                            credentials: 'include',
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ code }),
                        }).then(async res => {
                            if (!res.ok) {
                                setDataIsLoad(true);
                                return;
                            }
                            const data = await res.json();
                            if (data && data.manager) {
                                setManagerName(data.manager.name || '');
                                setManagerPhone(data.manager.phone || '');
                                setManagerEmail(data.manager.email || '');
                            }
                            setDataIsLoad(true);
                        }).catch(() => setDataIsLoad(true));
                    } else {
                        setDataIsLoad(true);
                    }
                } catch (e) {
                    setDataIsLoad(true);
                }
            }
        };

        const errorGetDataCallback = () => setDataIsLoad(true);

        getFetchRequest(makeUrl([GET_CURRENT_USER]), succesGetCurrentUserCallback, errorGetDataCallback);
    }, []);

    const handleChangeTab = (tabName) => {
        setIsCollapsed(null);
        navigate(`/${PAGE_MENU_LIST[tabName].key}`);
    };
    return (
        <nav className={`page-menu ${isCollapsed===null ? '': isCollapsed? 'page-menu_collapsed':'page-menu_full-width'}`}>
            <ul className={`menu__list ${isCollapsed===null ? '': isCollapsed? 'menu__list_collapsed':''}`}>
                <a href={`/${PAGE_MENU_LIST[PAGE_MENU_HOME].key}`} onClick={()=>handleChangeTab(PAGE_MENU_HOME)}
                    className={`menu__item ${isCollapsed===null ? '': isCollapsed? 'menu__item_collapsed':'menu__item_full-width'} navigation-link`} style={{ display: 'none' }}>
                    <HomeIcon nameOfClass={`menu__icon ${location.pathname.includes(PAGE_MENU_LIST[PAGE_MENU_HOME].key)?'menu__icon_active':''}`} />
                    <h2 className={`menu__title ${location.pathname.includes(PAGE_MENU_LIST[PAGE_MENU_HOME].key)? 'menu__title_active':''} ${isCollapsed===null ? '': isCollapsed? 'menu__title_collapsed':'menu__title_full-width'}`}>Домашняя страница</h2>
                    <p className={`menu__text ${isCollapsed===null ? '': isCollapsed? 'menu__text_collapsed':'menu__text_full-width'}`}>Актуальная информация по заказам и запросам, новости, уведомления</p>
                </a>
                <a href={`/${PAGE_MENU_LIST[PAGE_MENU_CATALOG].key}`} onClick={()=>handleChangeTab(PAGE_MENU_CATALOG)}
                    className={`menu__item ${isCollapsed===null ? '': isCollapsed? 'menu__item_collapsed':'menu__item_full-width'} navigation-link`} >
                    <CatalogIcon nameOfClass={`menu__icon ${location.pathname.includes(PAGE_MENU_LIST[PAGE_MENU_CATALOG].key)?'menu__icon_active':''}`} />
                    <h2 className={`menu__title ${isCollapsed===null ? '': isCollapsed? 'menu__title_collapsed':'menu__title_full-width'} ${location.pathname.includes(PAGE_MENU_LIST[PAGE_MENU_CATALOG].key)? 'menu__title_active':''}`}>Каталог</h2>
                    <p className={`menu__text ${isCollapsed===null ? '': isCollapsed? 'menu__text_collapsed':'menu__text_full-width'}`}>Расширенный поиск товаров, справочная информация</p>
                </a>
                <a href={`/${PAGE_MENU_LIST[PAGE_MENU_ORDERS].key}`} onClick={()=>handleChangeTab(PAGE_MENU_ORDERS)}
                    className={`menu__item ${isCollapsed===null ? '': isCollapsed? 'menu__item_collapsed':'menu__item_full-width'} navigation-link`}>
                    <OrdersIcon nameOfClass={`menu__icon ${location.pathname.includes(PAGE_MENU_LIST[PAGE_MENU_ORDERS].key)?'menu__icon_active':''}`} />
                    <h2 className={`menu__title ${isCollapsed===null ? '': isCollapsed? 'menu__title_collapsed':'menu__title_full-width'} ${location.pathname.includes(PAGE_MENU_LIST[PAGE_MENU_ORDERS].key)? 'menu__title_active':''}`}>Заказы</h2>
                    <p className={`menu__text ${isCollapsed===null ? '': isCollapsed? 'menu__text_collapsed':'menu__text_full-width'}`}>Совершение покупки, отгрузки, статусы заказов, печать документов</p>
                </a>
                <a href={`/${PAGE_MENU_LIST[PAGE_MENU_REQUESTS].key}`} onClick={()=>handleChangeTab(PAGE_MENU_REQUESTS)}
                    className={`menu__item ${isCollapsed===null ? '': isCollapsed? 'menu__item_collapsed':'menu__item_full-width'} navigation-link`} style={{ display: 'none' }}>
                    <RequestsIcon nameOfClass={`menu__icon ${location.pathname.includes(PAGE_MENU_LIST[PAGE_MENU_REQUESTS].key)?'menu__icon_active':''}`} />
                    <h2 className={`menu__title ${isCollapsed===null ? '': isCollapsed? 'menu__title_collapsed':'menu__title_full-width'} ${location.pathname.includes(PAGE_MENU_LIST[PAGE_MENU_REQUESTS].key)? 'menu__title_active':''}`}>Запросы</h2>
                    <p className={`menu__text ${isCollapsed===null ? '': isCollapsed? 'menu__text_collapsed':'menu__text_full-width'}`}>Запросы по ценам на товары из наличия и под заказ</p>
                </a>
                <a href={`/${PAGE_MENU_LIST[PAGE_MENU_ACCOUNTING].key}`} onClick={()=>handleChangeTab(PAGE_MENU_ACCOUNTING)}
                    className={`menu__item ${isCollapsed===null ? '': isCollapsed? 'menu__item_collapsed':'menu__item_full-width'} navigation-link`} style={{ display: 'none' }}>
                    <AccountingIcon nameOfClass={`menu__icon ${location.pathname.includes(PAGE_MENU_LIST[PAGE_MENU_ACCOUNTING].key)?'menu__icon_active':''}`} />
                    <h2 className={`menu__title ${isCollapsed===null ? '': isCollapsed? 'menu__title_collapsed':'menu__title_full-width'} ${location.pathname.includes(PAGE_MENU_LIST[PAGE_MENU_ACCOUNTING].key)? 'menu__title_active':''}`}>Бухгалтерия</h2>
                    <p className={`menu__text ${isCollapsed===null ? '': isCollapsed? 'menu__text_collapsed':'menu__text_full-width'}`}>Договора, авансовые счёт-фактуры, акты сверок, баланс</p>
                </a>
                <a href={`/${PAGE_MENU_LIST[PAGE_MENU_SETUP].key}`} onClick={()=>handleChangeTab(PAGE_MENU_SETUP)}
                    className={`menu__item ${isCollapsed===null ? '': isCollapsed? 'menu__item_collapsed':'menu__item_full-width'} navigation-link`} >
                    <SetupIcon nameOfClass={`menu__icon ${location.pathname.includes(PAGE_MENU_LIST[PAGE_MENU_SETUP].key)?'menu__icon_active':''}`} />
                    <h2 className={`menu__title ${isCollapsed===null ? '': isCollapsed? 'menu__title_collapsed':'menu__title_full-width'} ${location.pathname.includes(PAGE_MENU_LIST[PAGE_MENU_SETUP].key)? 'menu__title_active':''}`}>Настройки</h2>
                    <p className={`menu__text ${isCollapsed===null ? '': isCollapsed? 'menu__text_collapsed':'menu__text_full-width'}`}>Реквизиты компании, пользователи, адрес доставки</p>
                </a>
            </ul>
            {dataIsLoad && (
                <div className="page-menu__manager">
                    <span className="page-menu__manager-label">Ваш менеджер: <br />{managerName || '—'} <br />{managerPhone || '+7 (800) 500-75-25 доб. 101'} <br />{managerEmail || '101@auroraelec.ru'}</span>
                </div>
            )}
        </nav>
    );
};

export default Home;

Home.propTypes = {
    isCollapsed: PropTypes.any,
    setIsCollapsed: PropTypes.func,
};